// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5ec02ef6","732":"fbfd3df6"}[chunkId] + ".chunk.js";
};